import {Alert, IconButton, InputAdornment, Stack, TextField, Typography} from '@mui/material';
import {useState, useEffect} from 'react';
import API from '../../../services/API';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Layout from "../../Frames/Layout"
import {LoadingButton} from '@mui/lab';
import Loader from '../../Tools/Loader';
import { Close } from '@mui/icons-material';
import PDF from '../../Inputs/PDF';
import Category from '../../Inputs/Category';
import Variant from '../../Inputs/Variant';
import ProductType from '../../Inputs/ProductType';
import Picture from '../../Inputs/Picture';
import PackCourses from './PackCourses';
import uuid from 'react-uuid';

export default function Form(){

    const navigate = useNavigate();
    const {id} = useParams();

    const [product, setProduct] = useState({});
    const [status, setStatus] = useState('loading')
    const statusIs = str => str === status
    const statusIn = arr => arr.includes(status)

    useEffect(() => {

        if(id !== 'new'){

            API.get(`/products/${id}`)
                .then(r => {
                    setProduct(r.data)
                    setStatus('ready')
                })
                .catch(e => setStatus('error404'))

        }else{
            setProduct(defaultProduct())
            setStatus('ready')
        }

        return () => setProduct({})
                
    }, [id])


    const handleChange = props => {
        let copy = {...product};
        Object.assign(copy, props);
        return setProduct(copy);
    }

    const handleSubmit = e => {
        e.preventDefault();

        setStatus('submit');

        if(id === 'new'){

            API.post(`/products`, product)
                .then(r => navigate('/admin/products'))
                .catch(e => setStatus('error' + e.response.status))
        }else{
            API.put(`/products/${id}`, product)
                .then(r => navigate('/admin/products'))
                .catch(e => setStatus('error' + e.response.status))
        }
    }

    const handlePdf = pdf => {
        if(pdf){

            API.upload(`/pdf`, pdf)
                .then(r => setProduct({...product, pdf: r.data}))
                .catch(e => setStatus('errorPDF'))

        }else{

            API.delete(`/files/${product.pdf?.name}`)

            setProduct({...product, pdf: null})
        }
    }

    const handlePicture = picture => {
        if(picture){

            API.upload(`/pictures`, picture)
                .then(r => setProduct({...product, picture: r.data}))
                .catch(e => setStatus('errorPicture'))

        }else{

            API.delete(`/files/${product.picture?.name}`)

            setProduct({...product, picture: null})
        }
    }

    return <Layout title="" tab="products" menu="admin">

        {(status.startsWith('error') || statusIn(['ready','submit'])) && 
        
            <form onSubmit={e => handleSubmit(e)} style={{marginTop: 30}}>

                <Stack direction='column' spacing={3} sx={{maxWidth: 600, margin: 'auto'}}>

                    <Stack direction='row' justifyContent='space-between' alignItems='center'>

                        <Typography variant='h2'>{id === 'new' ? 'Ajouter un' : 'Modifier le '} produit</Typography>

                        <Link to="/admin/products">
                            <IconButton>
                                <Close />
                            </IconButton>
                        </Link>

                    </Stack>

                    {status.startsWith('error') && 
                        <Alert severity='error'>{errors[status] || errors.error500}</Alert>
                    }

                    <TextField
                        label='Désignation'
                        size='small'
                        value={product.title || ''}
                        onChange={e => handleChange({title: e.target.value})}
                        inputProps={{maxLength: 255}}
                        required
                    />

                    <ProductType
                        value={product.type}
                        onChange={type => handleChange({type})}
                        required
                    />

                    {product.type?.id === 'pack' &&

                        <PackCourses 
                            id={product.id}
                            value={product.children || []}
                            onChange={children => handleChange({children})}
                        />
                    }

                    <TextField
                        label='Prix'
                        type='number'
                        size='small'
                        value={product.price}
                        onChange={e => handleChange({price: e.target.value})}
                        InputProps={{
                            endAdornment: <InputAdornment position='end'>€</InputAdornment>,
                        }}
                        inputProps={{
                            min: 0,
                            step: 0.01
                        }}
                        required
                    />

                    <Variant
                        value={product.variant}
                        onChange={variant => handleChange({variant})}
                        required
                    />

                    <TextField
                        label='Référence 1'
                        size='small'
                        value={product.reference || ''}
                        onChange={e => handleChange({reference: e.target.value})}
                        inputProps={{maxLength: 100}}
                    />

                    <TextField
                        label='Référence 2'
                        size='small'
                        value={product.reference2 || ''}
                        onChange={e => handleChange({reference2: e.target.value})}
                        inputProps={{maxLength: 100}}
                    />

                    <Category 
                        value={product.category}
                        onChange={category => handleChange({category})}
                        required
                    />

                    <TextField
                        label='Durée'
                        type='number'
                        size='small'
                        value={product.hours}
                        onChange={e => handleChange({
                            hours: e.target.value,
                            duration: Math.round((e.target.value || 0) * 60)
                        })}
                        InputProps={{
                            endAdornment: <InputAdornment position='end'>heures</InputAdornment>,
                        }}
                        inputProps={{
                            min: 0,
                            step: 0.1,
                        }}
                        required
                    />

                    <Picture
                        id='product-picture'
                        value={product.picture} 
                        onChange={handlePicture}
                    />

                    <PDF
                        id='product-pdf'
                        value={product.pdf} 
                        onChange={handlePdf}
                    />

                    <LoadingButton 
                        variant='contained' 
                        type='submit' 
                        loading={statusIs('submit')}
                    >
                        Valider
                    </LoadingButton>

                </Stack>

            </form>
        }

        {statusIs('loading') && <Loader />}

    </Layout>
}


const errors = {
    error404: "Ce produit a été supprimé.",
    error409: "Ce produit existe déjà.",
    error500: "Une erreur s'est produite. Vérifiez le formulaire.",
    errorPDF: "PDF trop lourd ou format incorrect."
}


function defaultProduct() {

    const newId = uuid();

    return {
        id: newId,
        reference: null,
        type: {id: 'other', title: 'Autre'},
        variant: {id: 'other', title: 'Autre'},
        price: 0,
        duration: 0,
        hours: 0,
        category: {id: 'dentaire', title: 'Dentaire'},
        reference2: null,
        pdf: null
    };
}
